<template>
  <div>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <v-card v-else>
      <v-card-title>
        Editar {{persona.tipo}}
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <v-text-field
            counter
            label="Nombre"
            required
            v-model="persona.nombre"
            :error-messages="errorNombre"
            @input="$v.persona.nombre.$touch()"
            @blur="$v.persona.nombre.$touch()"
          ></v-text-field>
          <v-autocomplete
            label="Tipo de Responsable"
            :items="tipo_responsable"
            item-text="descripcion"
            item-value="codigo"
            v-model="persona.tipo_responsable"
            :error-messages="errorTipoResponsable"
            @input="$v.persona.tipo_responsable.$touch()"
            @blur="$v.persona.tipo_responsable.$touch()"
          ></v-autocomplete>
          <v-autocomplete
            label="Tipo de Documento"
            :items="tipo_documento"
            item-text="descripcion"
            item-value="codigo"
            v-model="persona.documento.tipo"
            :error-messages="errorTipoDocumento"
            @input="$v.persona.documento.tipo.$touch()"
            @blur="$v.persona.documento.tipo.$touch()"
          ></v-autocomplete>
          <v-text-field
            counter
            label="Numero de Documento"
            required
            v-model="persona.documento.numero"
            :error-messages="errorNumeroDocumento"
            @input="$v.persona.documento.numero.$touch()"
            @blur="$v.persona.documento.numero.$touch()"
          ></v-text-field>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Direccion</th>
                  <th class="text-left">Descripcion</th>
                  <th class="text-left">Ciudad</th>
                  <th class="text-left">Provincia</th>
                  <th class="text-left">C.P.</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in persona.direcciones" :key="item._id">
                  <td>{{ item.direccion_1 }} {{ item.direccion_2 }}</td>
                  <td>{{ item.descripcion }}</td>
                  <td>
                    {{
                      item.ciudad && item.ciudad.nombre
                        ? item.ciudad.nombre
                        : null
                    }}
                  </td>
                  <td>
                    {{
                      item.provincia && item.provincia.nombre
                        ? item.provincia.nombre
                        : null
                    }}
                  </td>
                  <td>{{ item.cp }}</td>
                  <td>
                    <v-icon small class="mr-2" @click="_editarDireccion(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon small class="mr-2" @click="_borrarDireccion(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <span class="red--text" v-if="$v.persona.direcciones.$invalid"
            >Se debe ingresar al menos una direccion</span
          >
          <v-btn class="ma-2" block small @click="_editarDireccion(false)"
            >Agregar Direccion</v-btn
          >
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Medio de Contacto</th>
                  <th class="text-left">Datos</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in persona.contactos" :key="item._id">
                  <td>{{ item.medio }}</td>
                  <td>{{ item.dato }}</td>
                  <td>
                    <v-icon small class="mr-2" @click="_editarContacto(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon small class="mr-2" @click="_borrarContacto(item)"
                      >mdi-delete</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-btn class="ma-2" block small @click="_editarContacto(false)"
            >Agregar Contacto</v-btn
          >
          <v-divider></v-divider>
          <v-btn
            class="ma-2"
            block
            :color="$v.persona.$invalid ? 'error' : 'success'"
            @click="guardarCliente()"
          >
            <v-icon left>
              {{ $v.persona.$invalid ? "mdi-close" : "mdi-check" }} </v-icon
            >Guardar {{persona.tipo}}
          </v-btn>
        </form>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogDireccion" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline" v-if="direccion.index > -1"
            >Editar Direccion</span
          >
          <span class="headline" v-else>Agregar Direccion</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              label="Descripcion"
              required
              v-model="direccion.descripcion"
              :error-messages="errorDireccionDescripcion"
              @input="$v.direccion.descripcion.$touch()"
              @blur="$v.direccion.descripcion.$touch()"
            ></v-text-field>
            <v-text-field
              label="Direccion"
              required
              v-model="direccion.direccion_1"
              :error-messages="errorDireccion1"
              @input="$v.direccion.direccion_1.$touch()"
              @blur="$v.direccion.direccion_1.$touch()"
            ></v-text-field>
            <v-text-field
              v-model="direccion.direccion_2"
              label="Adicionales"
              hint="Piso, Dpto, Local, etc."
              persistent-hint
            ></v-text-field>
            <v-autocomplete
              label="Provincia"
              required
              v-model="direccion.provincia"
              :items="provincias"
              item-text="nombre"
              item-value="_id"
              return-object
              :error-messages="errorDireccionProvincia"
              @input="$v.direccion.provincia.$touch()"
              @blur="$v.direccion.provincia.$touch()"
              @change="cargarCiudades()"
            ></v-autocomplete>
            <v-autocomplete
              label="Ciudad"
              required
              v-model="direccion.ciudad"
              :items="ciudades"
              item-text="nombre"
              item-value="_id"
              return-object
              :error-messages="errorDireccionCiudad"
              @input="$v.direccion.ciudad.$touch()"
              @blur="$v.direccion.ciudad.$touch()"
            ></v-autocomplete>
            <v-text-field
              label="Codigo Postal"
              required
              v-model="direccion.cp"
              :error-messages="errorDireccionCP"
              @input="$v.direccion.cp.$touch()"
              @blur="$v.direccion.cp.$touch()"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogDireccion = false"
            >Cancelar</v-btn
          >
          <v-btn color="green darken-1" text @click="_guardarDireccion()"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogContacto" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline" v-if="contacto.index > -1"
            >Editar Contacto</span
          >
          <span class="headline" v-else>Agregar Contacto</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              label="Medio de Contacto"
              required
              v-model="contacto.medio"
              :error-messages="errorContactoMedio"
              @input="$v.contacto.medio.$touch()"
              @blur="$v.contacto.medio.$touch()"
            ></v-text-field>
            <v-text-field
              label="Dato"
              required
              v-model="contacto.dato"
              :error-messages="errorContactoDato"
              @input="$v.contacto.dato.$touch()"
              @blur="$v.contacto.dato.$touch()"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialogContacto = false"
            >Cancelar</v-btn
          >
          <v-btn color="green darken-1" text @click="_guardarContacto()"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  name: "Clientes_Nuevo",
  data() {
    return {
      loading: true,
      dialogDireccion: false,
      dialogContacto: false,
      persona: {
        nombre: "",
        tipo: "",
        tipo_responsable: "",
        documento: {
          tipo: "",
          numero: "",
        },
        direcciones: [],
        contactos: [],
      },
      tipo_responsable: [],
      tipo_documento: [],
      direccion: {
        descripcion: "",
        direccion_1: "",
        direccion_2: "",
        ciudad: "",
        provincia: "",
        pais: "600d85b372a88c3dd40bbadf",
        cp: "",
      },
      contacto: {
        medio: "",
        dato: "",
      },
      ciudades: [],
      provincias: [],
    };
  },
  validations: {
    persona: {
      nombre: { required, minLength: minLength(3) },
      tipo_responsable: { required },
      documento: {
        tipo: { required },
        numero: { required, minLength: minLength(3) },
      },
      direcciones: { required },
    },
    direccion: {
      descripcion: { required, minLength: minLength(3) },
      direccion_1: { required, minLength: minLength(3) },
      ciudad: { required, minLength: minLength(3) },
      provincia: { required, minLength: minLength(3) },
      cp: { required, minLength: minLength(3) },
    },
    contacto: {
      medio: { required, minLength: minLength(3) },
      dato: { required, minLength: minLength(3) },
    },
  },
  methods: {
    async guardarCliente() {
      this.$v.persona.$touch();
      if (!this.$v.persona.$invalid) {
        this.loading = true;
        try {
          let direcciones = this.persona.direcciones.map((val) => ({
            ...val,
            ciudad: val.ciudad._id,
            provincia: val.provincia._id,
          }));
          let persona = {
            ...this.persona,
            direcciones,
          };
          await axios.put(`/persona/${this.id}`, persona);
          this.obtenerCliente();
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
      }
    },
    async obtenerTiposFiscales() {
      try {
        const tipos = await axios.get("/sucursal/tiposFiscales");
        this.tipo_responsable = tipos.data.tiposResponsable;
        this.tipo_documento = tipos.data.tiposDocumento;
      } catch (error) {
        console.log(error);
      }
    },
    _guardarDireccion() {
      this.$v.direccion.$touch();
      if (!this.$v.direccion.$invalid) {
        if (this.direccion.index > -1) {
          let index = this.direccion.index;
          this.persona.direcciones[index] = this.direccion;
        } else {
          this.persona.direcciones.push(this.direccion);
        }
        this.dialogDireccion = false;
      }
    },
    _editarDireccion(item) {
      let index = this.persona.direcciones.indexOf(item);
      if (index > -1) {
        this.direccion = this.persona.direcciones[index];
      } else {
        this.direccion = {
          descripcion: "",
          direccion_1: "",
          direccion_2: "",
          ciudad: "",
          provincia: "",
          pais: "600d85b372a88c3dd40bbadf", //malo malo que este asi aca
          cp: "",
        };
      }
      this.direccion.index = index;
      this.$v.direccion.$reset();
      this.dialogDireccion = true;
    },
    _borrarDireccion(item) {
      let index = this.persona.direcciones.indexOf(item);
      if (index > -1) this.persona.direcciones.splice(index, 1);
    },
    _guardarContacto() {
      this.$v.contacto.$touch();
      if (!this.$v.contacto.$invalid) {
        if (this.contacto.index > -1) {
          let index = this.contacto.index;
          this.persona.contactos[index] = this.contacto;
        } else {
          this.persona.contactos.push(this.contacto);
        }
        this.dialogContacto = false;
      }
    },
    _editarContacto(item) {
      let index = this.persona.contactos.indexOf(item);
      if (index > -1) {
        this.contacto = this.persona.contactos[index];
      } else {
        this.contacto = {
          medio: "",
          dato: "",
        };
      }
      this.contacto.index = index;
      this.$v.contacto.$reset();
      this.dialogContacto = true;
    },
    _borrarContacto(item) {
      let index = this.persona.contactos.indexOf(item);
      if (index > -1) this.persona.contactos.splice(index, 1);
    },
    _cerrar() {
      this.$router.go(-1);
    },
    async obtenerProvincias() {
      try {
        const provincias = await axios.post("/tienda/registro/buscarCiudad");
        this.provincias = provincias.data.provincias;
      } catch (error) {
        console.log(error);
      }
    },
    async cargarCiudades() {
      try {
        const ciudades = await axios.post("/tienda/registro/buscarCiudad", {
          provincia: this.direccion.provincia._id,
        });
        this.ciudades = ciudades.data.ciudades;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerCliente() {
      try {
        const cliente = await axios.get(`/persona/${this.id}`);
        this.persona = cliente.data;
        this.loading = false;
      } catch (error) {
        this.$router.push(`/clientes/`);
      }
    },
  },
  async created() {
    this.obtenerTiposFiscales();
    this.obtenerProvincias();
    this.obtenerCliente();
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    errorNombre() {
      const errors = [];
      if (!this.$v.persona.nombre.$dirty) return errors;
      !this.$v.persona.nombre.minLength &&
        errors.push("El Nombre debe tener al menos 3 caracteres.");
      !this.$v.persona.nombre.required &&
        errors.push("Debe ingresar un Nombre.");
      return errors;
    },
    errorTipoResponsable() {
      const errors = [];
      if (!this.$v.persona.tipo_responsable.$dirty) return errors;
      !this.$v.persona.tipo_responsable.required &&
        errors.push("Debe seleccionar un Tipo de Responsable.");
      return errors;
    },
    errorTipoDocumento() {
      const errors = [];
      if (!this.$v.persona.documento.tipo.$dirty) return errors;
      !this.$v.persona.documento.tipo.required &&
        errors.push("Debe seleccionar un Tipo de Documento.");
      return errors;
    },
    errorNumeroDocumento() {
      const errors = [];
      if (!this.$v.persona.documento.numero.$dirty) return errors;
      !this.$v.persona.documento.numero.minLength &&
        errors.push("El Numero de Documento debe tener al menos 3 caracteres.");
      !this.$v.persona.documento.numero.required &&
        errors.push("Debe ingresar un Numero de Documento.");
      return errors;
    },
    errorDireccionDescripcion() {
      const errors = [];
      if (!this.$v.direccion.descripcion.$dirty) return errors;
      !this.$v.direccion.descripcion.minLength &&
        errors.push(
          "La Descripcion de la Direccion debe tener al menos 3 caracteres."
        );
      !this.$v.direccion.descripcion.required &&
        errors.push("Debe ingresar una Descripcion de la Direccion.");
      return errors;
    },
    errorDireccion1() {
      const errors = [];
      if (!this.$v.direccion.direccion_1.$dirty) return errors;
      !this.$v.direccion.direccion_1.minLength &&
        errors.push("La Direccion debe tener al menos 3 caracteres.");
      !this.$v.direccion.direccion_1.required &&
        errors.push("Debe ingresar una Direccion.");
      return errors;
    },
    errorDireccionCiudad() {
      const errors = [];
      if (!this.$v.direccion.ciudad.$dirty) return errors;
      !this.$v.direccion.ciudad.minLength &&
        errors.push("La Ciudad debe tener al menos 3 caracteres.");
      !this.$v.direccion.ciudad.required &&
        errors.push("Debe ingresar una Ciudad.");
      return errors;
    },
    errorDireccionProvincia() {
      const errors = [];
      if (!this.$v.direccion.provincia.$dirty) return errors;
      !this.$v.direccion.provincia.minLength &&
        errors.push("La Provincia debe tener al menos 3 caracteres.");
      !this.$v.direccion.provincia.required &&
        errors.push("Debe ingresar una Provincia.");
      return errors;
    },
    errorDireccionCP() {
      const errors = [];
      if (!this.$v.direccion.cp.$dirty) return errors;
      !this.$v.direccion.cp.minLength &&
        errors.push("El Codigo Postal debe tener al menos 3 caracteres.");
      !this.$v.direccion.cp.required &&
        errors.push("Debe ingresar un Codigo Postal.");
      return errors;
    },
    errorContactoMedio() {
      const errors = [];
      if (!this.$v.contacto.medio.$dirty) return errors;
      !this.$v.contacto.medio.minLength &&
        errors.push("El Medio de Contacto debe tener al menos 3 caracteres.");
      !this.$v.contacto.medio.required &&
        errors.push("Debe ingresar un Medio de Contacto.");
      return errors;
    },
    errorContactoDato() {
      const errors = [];
      if (!this.$v.contacto.dato.$dirty) return errors;
      !this.$v.contacto.dato.minLength &&
        errors.push("El Dato de Contacto debe tener al menos 3 caracteres.");
      !this.$v.contacto.dato.required &&
        errors.push("Debe ingresar un Dato de Contacto.");
      return errors;
    },
  },
};
</script>
